import { BatchRepository, Batch, BatchFactory } from '@/Domain/Batch'
import { ProcedureId, ProcedureNotFoundError } from '@/Domain/Procedures'
import store from '@/Infrastructure/Store'
import { BatchDto } from '@/Application/Batch'
import { AccountId } from '@/Domain/Account'

export class VuexBatchRepository implements BatchRepository {
  private _factory: BatchFactory<BatchDto>

  constructor (factory: BatchFactory<BatchDto>) {
    this._factory = factory
  }

  async byProcedureId (procedureId: ProcedureId): Promise<Batch[]> {
    const storedProcedure = store.getters['procedure/currentProcedure']
    try {
      if (!storedProcedure || storedProcedure.procedureId !== procedureId.id) {
        throw new ProcedureNotFoundError(`Procedure ${procedureId.id} not found`)
      }
      const batches: Batch[] = []
      const batchesData = [
        ...store.getters['procedure/resultasBatches'],
        ...store.getters['procedure/riscoBatches']
      ]
      for (const batch of batchesData) {
        batches.push(this._factory.makeBatch(batch))
      }
      return Promise.resolve(batches)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  // eslint-disable-next-line
  async byProcedureIdAndUserIdWithOffers (procedureId: ProcedureId, accountId: AccountId): Promise<Batch[]> {
    return Promise.resolve([])
  }
}
